//console.log("global");
jQuery(function($) {
	/*$("body").on('click', '.nav-trigger', function(e) {
        e.preventDefault();
        $("body").toggleClass('off-canvas-body');
        $("html").toggleClass('off-canvas-overflow');
        $(".main-navigation").toggleClass("off-canvas");
    });

    $('body').on("click", ".menu-header-menu-container .menu-item-has-children > .am-submenu-toggle", function(e) {
        e.preventDefault();
        e.stopPropagation();
		$(this).toggleClass('open-sub-am-menu');
		$(this).closest('.menu-item-has-children').toggleClass('spacing-list');
        $(this).next('.am-submenu-list').slideToggle(600);
    });*/
	
	$('.site-inner-head-wrap').mobileMegaMenu({
		changeToggleText: true,
		enableWidgetRegion: true,
		prependCloseButton: true,
		stayOnActive: true,
		toogleTextOnClose: 'Close Menu',
		menuToggle: 'main-menu-toggle'
	});

	$("body").on('click', '.header-search-toggle-btn', function(e) {
        e.preventDefault();
        $("body").toggleClass('off-search-canvas-body');
        $("html").toggleClass('off-search-canvas-overflow');
        $(".header-common-contact-data.header-search-data").toggleClass("off-canvas");
    });
	
	$('body').on("click", '.foot-col-title', function(e) {
        e.preventDefault();
        $(this).closest('.footer-common-column-wrap').find('.footer-column-menu-wrap').slideToggle(600);
        $(this).toggleClass("open");
    });
	
	$('body').on("click", '.tech-tips-sin-block-heading-wrap', function(e) {
        e.preventDefault();
        var get_current_data_acc = $(this).closest('.tech-tips-sin-block-title-wrap').data('accordion');
		
		$(this).closest('.tech-tips-sin-block-outer-wrap').find('.tech-tips-sin-block-heading-wrap').removeClass('active');
        $(this).toggleClass("active");
		$(this).closest('.tech-tips-sin-block-table-data-wrap').find('.tech-tips-sin-title-content-main-wrapper').removeClass('active');
		
		$(this).closest('.tech-tips-sin-block-table-data-wrap').find('.tech-tips-sin-title-content-main-wrapper').each(function() {
			if($(this).data('accordion') === get_current_data_acc) {
				$(this).toggleClass("active");
			}
		});
    });
	
	$('body').on("click", '.faq-sin-que-wrap', function(e) {
        e.preventDefault();
        $(this).closest('.faq-sin-outer-wrap').toggleClass("open");
        $(this).toggleClass("open");
    });
	
	if($('.home-icon-wrapper').length) {
		$('.home-icon-wrapper').html('<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2.45455 16.5V9L0.981818 10.1L0 8.82L2.45455 6.98V4.5H4.09091V5.76L9 2.1L18 8.82L17.0182 10.08L15.5455 9V16.5H9.81818V11.7H8.18182V16.5H2.45455ZM2.45455 3.7C2.45455 3.03333 2.69318 2.46667 3.17045 2C3.64773 1.53333 4.22727 1.3 4.90909 1.3C5.14091 1.3 5.33523 1.22333 5.49205 1.07C5.64886 0.916667 5.72727 0.726667 5.72727 0.5H7.36364C7.36364 1.16667 7.125 1.73333 6.64773 2.2C6.17045 2.66667 5.59091 2.9 4.90909 2.9C4.67727 2.9 4.48295 2.97667 4.32614 3.13C4.16932 3.28333 4.09091 3.47333 4.09091 3.7H2.45455Z" fill="#741012"/> </svg>');
	}

    $(document).on("click", function(e) {
		//console.log($(e.target));
		if ($(e.target).closest('.header-common-contact-data.header-search-data').length === 0 && $(e.target).closest('.header-search-toggle-btn').length === 0) {
            $("body").removeClass('off-search-canvas-body');
            $("html").removeClass('off-search-canvas-overflow');
            $(".header-common-contact-data.header-search-data").removeClass("off-canvas");
        }
    });
	
	$(document).ready(function() {
		$('.popup-youtube, .popup-vimeo').magnificPopup({
			/*type: 'iframe',
			mainClass: 'mfp-fade',*/
			type: 'inline',
			removalDelay: 160,
			closeBtnInside: true,
			preloader: false,
			fixedContentPos: false,
			/*modal: true,*/
			mainClass: 'my-mfp-zoom-in',
			callbacks: {
				beforeOpen: function() {
					// When the popup opens, hide the body's scrollbar
					$('html').addClass('overflow-y-hide');
				},
				close: function() {
					// When the popup closes, restore the body's scrollbar
					$('html').removeClass('overflow-y-hide');
				}
			}
		});
	});
	
	/***************************/
    if ($('.pcs-banner-slider-wrap.wcslide-init').length) {
		const pcs_banner_slider = document.querySelectorAll(".pcs-banner-slider-wrap.wcslide-init");
        for (var i = 0; i < pcs_banner_slider.length; i++) {
			var pcs_final_banner_slider = pcs_banner_slider[i];

			if ($(pcs_final_banner_slider).hasClass('slick-initialized')) {
				$(pcs_final_banner_slider).slick('unslick');
			}

			$(pcs_final_banner_slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: Boolean(Number($(pcs_final_banner_slider).data('autoplay'))),
				autoplaySpeed: parseInt($(pcs_final_banner_slider).data('speed')),
				infinite: false,
				dots: Boolean(Number($(pcs_final_banner_slider).data('dots'))),
				arrows: Boolean(Number($(pcs_final_banner_slider).data('arrows'))),
				prevArrow: '<button class="slick-arrow slick-prev"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.4606 19.0304L11.1941 17.2773L3.76175 9.85335L11.1941 2.42944L9.4606 0.67627L0.2731 9.85335L9.4606 19.0304Z" fill="white"/></svg><div class="screen-reader-text">Previous</div></button>',
				nextArrow: '<button class="slick-arrow slick-next"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.58481 19.0304L0.851318 17.2773L8.28366 9.85335L0.851318 2.42944L2.58481 0.67627L11.7723 9.85335L2.58481 19.0304Z" fill="#606060"/></svg><div class="screen-reader-text">Next</div></button>',
			});
		}
    }
    /***************************/
	
	/***************************/
    if ($('.testimonial-slider-wrap.wcslide-init').length) {
		const testimonial_slider = document.querySelectorAll(".testimonial-slider-wrap.wcslide-init");
        for (var i = 0; i < testimonial_slider.length; i++) {
			var testimonial_final_slider = testimonial_slider[i];

			if ($(testimonial_final_slider).hasClass('slick-initialized')) {
				$(testimonial_final_slider).slick('unslick');
			}

			$(testimonial_final_slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: Boolean(Number($(testimonial_final_slider).data('autoplay'))),
				autoplaySpeed: parseInt($(testimonial_final_slider).data('speed')),
				infinite: false,
				mobileFirst: true,
				dots: Boolean(Number($(testimonial_final_slider).data('dots'))),
				arrows: Boolean(Number($(testimonial_final_slider).data('arrows'))),
				prevArrow: '<button class="slick-arrow slick-prev"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.4606 19.0304L11.1941 17.2773L3.76175 9.85335L11.1941 2.42944L9.4606 0.67627L0.2731 9.85335L9.4606 19.0304Z" fill="white"/></svg><div class="screen-reader-text">Previous</div></button>',
				nextArrow: '<button class="slick-arrow slick-next"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.58481 19.0304L0.851318 17.2773L8.28366 9.85335L0.851318 2.42944L2.58481 0.67627L11.7723 9.85335L2.58481 19.0304Z" fill="#606060"/></svg><div class="screen-reader-text">Next</div></button>',
			});
		}
    }
    /***************************/
	
	/***************************/
    if ($('.gallery-image-slider-outer-wrap.wcslide-init').length) {
		const gallery_image_slider = document.querySelectorAll(".gallery-image-slider-outer-wrap.wcslide-init");
        for (var i = 0; i < gallery_image_slider.length; i++) {
			var gallery_image_final_slider = gallery_image_slider[i];

			if ($(gallery_image_final_slider).hasClass('slick-initialized')) {
				$(gallery_image_final_slider).slick('unslick');
			}

			$(gallery_image_final_slider).slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: Boolean(Number($(gallery_image_final_slider).data('autoplay'))),
				autoplaySpeed: parseInt($(gallery_image_final_slider).data('speed')),
				infinite: true,
				variableWidth: true,
				mobileFirst: true,
				dots: false,
				arrows: Boolean(Number($(gallery_image_final_slider).data('arrows'))),
				prevArrow: '<button class="slick-arrow slick-prev"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1217 21.4652L13.1028 19.4616L4.60874 10.9771L13.1028 2.49264L11.1217 0.489014L0.62171 10.9771L11.1217 21.4652Z" fill="#2D2D2D"/></svg><div class="screen-reader-text">Previous</div></button>',
				nextArrow: '<button class="slick-arrow slick-next"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.87823 21.4652L0.897095 19.4616L9.3912 10.9771L0.897095 2.49264L2.87823 0.489014L13.3782 10.9771L2.87823 21.4652Z" fill="#2D2D2D"/></svg><div class="screen-reader-text">Next</div></button>',
				responsive: [
					{
						breakpoint: 801,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 551,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					}
				]
			});
		}
    }
    /***************************/
	
	/***************************/
    if ($('.cpg-repeater-data.wcslide-init').length) {
		const cpg_lightbox_slider = document.querySelectorAll(".cpg-repeater-data.wcslide-init");
        for (var i = 0; i < cpg_lightbox_slider.length; i++) {
			var cpg_lightbox_final_slider = cpg_lightbox_slider[i];

			if ($(cpg_lightbox_final_slider).hasClass('slick-initialized')) {
				$(cpg_lightbox_final_slider).slick('unslick');
			}

			$(cpg_lightbox_final_slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: Boolean(Number($(cpg_lightbox_final_slider).data('autoplay'))),
				autoplaySpeed: parseInt($(cpg_lightbox_final_slider).data('speed')),
				infinite: true,
				variableWidth: true,
				mobileFirst: true,
				dots: false,
				arrows: Boolean(Number($(cpg_lightbox_final_slider).data('arrows'))),
				prevArrow: '<button class="slick-arrow slick-prev"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1217 21.4652L13.1028 19.4616L4.60874 10.9771L13.1028 2.49264L11.1217 0.489014L0.62171 10.9771L11.1217 21.4652Z" fill="#2D2D2D"/></svg><div class="screen-reader-text">Previous</div></button>',
				nextArrow: '<button class="slick-arrow slick-next"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.87823 21.4652L0.897095 19.4616L9.3912 10.9771L0.897095 2.49264L2.87823 0.489014L13.3782 10.9771L2.87823 21.4652Z" fill="#2D2D2D"/></svg><div class="screen-reader-text">Next</div></button>',
			});
		}
    }
	//$(".my-slider .slick-slide.slick-cloned a").removeAttr("data-lightbox");
    /***************************/
	
	/***************************/
    if ($('.prd-testimonial-slider-wrap.wcslide-init').length) {
		const prd_testimonial_slider = document.querySelectorAll(".prd-testimonial-slider-wrap.wcslide-init");
        for (var i = 0; i < prd_testimonial_slider.length; i++) {
			var prd_testimonial_final_slider = prd_testimonial_slider[i];

			if ($(prd_testimonial_final_slider).hasClass('slick-initialized')) {
				$(prd_testimonial_final_slider).slick('unslick');
			}

			$(prd_testimonial_final_slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: Boolean(Number($(prd_testimonial_final_slider).data('autoplay'))),
				autoplaySpeed: parseInt($(prd_testimonial_final_slider).data('speed')),
				infinite: true,
				mobileFirst: true,
				dots: Boolean(Number($(prd_testimonial_final_slider).data('dots'))),
				arrows: Boolean(Number($(prd_testimonial_final_slider).data('arrows'))),
				prevArrow: '<button class="slick-arrow slick-prev"><svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4503 27.1099L15.9268 24.6054L5.30913 13.9998L15.9268 3.39418L13.4503 0.889648L0.32534 13.9998L13.4503 27.1099Z" fill="#606060"/></svg><div class="screen-reader-text">Previous</div></button>',
				nextArrow: '<button class="slick-arrow slick-next"><svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.54966 27.1099L0.0732422 24.6054L10.6909 13.9998L0.0732422 3.39418L2.54966 0.889648L15.6747 13.9998L2.54966 27.1099Z" fill="#606060"/></svg><div class="screen-reader-text">Next</div></button>',
				responsive: [
					{
						breakpoint: 1261,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 641,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					}
				]
			});
		}
    }
    /***************************/
	
	if($('.cpg-repeater-data').length) {
		lightbox.option({
			'wrapAround': true,
			'albumLabel': '',
		});
	}
	
	$('body').on('keypress', '.pc-gap-footage-size-data', function(evt) {
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if (charCode == 46) {
			//Check if the text already contains the . character
			if ($(this).val().indexOf('.') === -1) {
				return true;
			} else {
				return false;
			}
		} else {
			if (charCode > 31 && (charCode < 48 || charCode > 57))
				return false;
		}
		return true;
	});
	
	$('body').on('click', '.calculate-pc-es-data-btn', function() {
		
		let gap_data = $(this).closest('form').find('.pc-gap-size-data').val();
		let footage_data = $(this).closest('form').find('.pc-footage-size-data').val();
		
		let total_calc = 0;
		
		if($(this).closest('.pcs-prd-calc-form-wrapper').hasClass('perma-chink')) {
			
			total_calc = (gap_data * footage_data)/385;
			
		}
		else {
			
			total_calc = (gap_data * footage_data)/490;
			
		}
		if(total_calc > 0) {
			$(this).closest('form').find('.final-calculated-val').val(total_calc.toFixed(2));
		}
	});
	
	
	$('body').on('click', '.photo-sin-modal-data-wrapper', function() {
		
		$('#photo-popup-modal').find('.pp-modal-photo-title-wrap').html($(this).closest('.photos-main-data-sin-grid').find('.pp-title-data-wrap').html());
		$('#photo-popup-modal').find('.pp-modal-photo-img-wrap img').attr('src',$(this).closest('.photos-main-data-sin-grid').find('.photo-sin-img-wrap').find('img').attr('src'));
		
		if($(this).closest('.photos-main-data-sin-grid').find('.pp-desc-data-wrap').length) {
			$('#photo-popup-modal').find('.pp-modal-photo-desc-wrap').html($(this).closest('.photos-main-data-sin-grid').find('.pp-desc-data-wrap').html());
		}
		else {
			$('#photo-popup-modal').find('.pp-modal-photo-desc-wrap').html('');
		}
		
		if($(this).closest('.photos-main-data-sin-grid').find('.pp-prd-feat-title-wrap').length) {
			$('#photo-popup-modal').find('.pp-modal-prd-title-wrap').html($(this).closest('.photos-main-data-sin-grid').find('.pp-prd-feat-title-wrap').html());
		}
		else {
			$('#photo-popup-modal').find('.pp-modal-prd-title-wrap').html('');
		}
		
		if($(this).closest('.photos-main-data-sin-grid').find('.pp-featured-prdts-list-wrap').length) {
			$('#photo-popup-modal').find('.pp-modal-prdts-loop-wrapper').html($(this).closest('.photos-main-data-sin-grid').find('.pp-featured-prdts-list-wrap').html());
		}
		else {
			$('#photo-popup-modal').find('.pp-modal-prdts-loop-wrapper').html('');
		}
		
		$('#photo-popup-modal').css({'display':'block'});
		
		if(!$(this).closest('.photos-main-data-sin-grid').hasClass('active')) {
			$(this).closest('.photos-main-data-sin-grid').addClass('active');
		}
		if(!$("body").hasClass('pp-canvas-body')) {
			$("body").addClass('pp-canvas-body');
		}
		if(!$("html").hasClass('pp-canvas-overflow')) {
			$("html").addClass('pp-canvas-overflow');
		}
	});
	$('body').on('click', '.photo-popup-close', function() {
		$('#photo-popup-modal').css({'display':'none'});
		
		$('.photos-main-data-sin-grid').removeClass('active');
		$("body").removeClass('pp-canvas-body');
        $("html").removeClass('pp-canvas-overflow');
	});
	
	/*$(document).on('click', function(e) {
		//console.log($(e.target).parent().hasClass('photo-sin-modal-data-wrapper'));
		if ($(e.target).closest('#photo-popup-modal').length === 0 && !$(e.target).parent().hasClass('photo-sin-modal-data-wrapper')) {
			$('#photo-popup-modal').css({'display':'none'});
			
			$('.photos-main-data-sin-grid').removeClass('active');
			$("body").removeClass('pp-canvas-body');
			$("html").removeClass('pp-canvas-overflow');
		}
	});*/
	
	$('body').on('click', '.pp-arrow-prev', function() {
		let count_photos = $('.photos-main-data-wrapper').find('.photos-main-data-sin-grid').length;
		let current_opened_modal = $('.photos-main-data-wrapper').find('.photos-main-data-sin-grid.active').index();
		
		$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid').removeClass('active');
		
		if(current_opened_modal === 0) {
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq('+(count_photos - 1)+')').addClass('active');
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq('+(count_photos - 1)+')').find('.photo-sin-modal-data-wrapper').click();
		}
		else {
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq('+(current_opened_modal - 1)+')').addClass('active');
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq('+(current_opened_modal - 1)+')').find('.photo-sin-modal-data-wrapper').click();
		}
	});
	
	$('body').on('click', '.pp-arrow-next', function() {
		let count_photos = $('.photos-main-data-wrapper').find('.photos-main-data-sin-grid').length;
		let current_opened_modal = $('.photos-main-data-wrapper').find('.photos-main-data-sin-grid.active').index();
		
		$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid').removeClass('active');
		
		if(count_photos === (current_opened_modal + 1)) {
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq(0)').addClass('active');
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq(0)').find('.photo-sin-modal-data-wrapper').click();
		}
		else {
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq('+(current_opened_modal + 1)+')').addClass('active');
			$('.photos-main-data-wrapper').find('.photos-main-data-sin-grid:eq('+(current_opened_modal + 1)+')').find('.photo-sin-modal-data-wrapper').click();
		}
	});
	
	var filter_sidebar_modal = document.getElementById("filter-sidebar-popup");

	var filter_sidebar_btn = document.getElementById("filter_sidebar_modal_btn");

	var filter_sidebar_span = document.getElementsByClassName("filter_sidebar_modal_close")[0];
	
	if(filter_sidebar_modal !== null) {
		if(filter_sidebar_btn !== null) {
			filter_sidebar_btn.onclick = function() {
			  filter_sidebar_modal.style.display = "block";
			}
		}
		
		if(filter_sidebar_span !== null) {
			filter_sidebar_span.onclick = function() {
			  filter_sidebar_modal.style.display = "none";
			}
		}

		window.onclick = function(event) {
		  if (event.target == filter_sidebar_modal) {
			filter_sidebar_modal.style.display = "none";
		  }
		}
	}
	
	$('body').on('click', '.diy-vid-popup-link', function(e) {
		var get_href_elem = $(this).attr('href');
		if($(get_href_elem).length) {
			$(get_href_elem).find('iframe.iframe-modal-video').attr('src', $(this).data('vidlink'));
		}
	});
	
	$('body').on('click', 'a[rel="relativeanchor"]', function(e){
		e.preventDefault();
		e.stopPropagation();
		if($( $.attr(this, 'href') ).length) {
			$('html, body').animate({
				scrollTop: $( $.attr(this, 'href') ).offset().top
			}, 800);
			return false;
		}
	});
	
	if($('.table-index-l-dt-cnt-wrap').length) {
		var get_table_index_contents = '';
		
		$('.tech-tips-title-wrap').each(function(a,b) {
			var get_link_anchor = $(this).closest('.tech-tips-main-outer-wrap').attr('id');
			get_table_index_contents += '<div><a rel="relativeanchor" href="#'+get_link_anchor+'">'+$(this).html()+'</a></div>';
		});
		
		$('.table-index-l-dt-cnt-wrap').html(get_table_index_contents);
	}
	
	$(".pcs-path-slider-outer-container").mCustomScrollbar({
		axis:"x",
		scrollInertia:1000,
		horizontalScroll:true,
		mouseWheelPixels:396,
		scrollButtons:{
			enable:true,
			scrollType:"pixels",
			scrollAmount:396
		},
		advanced:{autoExpandHorizontalScroll:true},
		callbacks:{
			onScrollStart:function(){
				$('.mCSB_buttonLeft').addClass('on');
				$('.mCSB_buttonRight').removeClass('off');
			},
			onScroll:function(){
				snapScrollbar();
			},
			onTotalScroll:function(){
				$('.mCSB_buttonRight').addClass('off');
			},
			onTotalScrollBack:function(){
				$('.mCSB_buttonLeft').removeClass('on');
				$('.mCSB_buttonRight').removeClass('off');
			},
			whileScrolling:function(){
				
			},
			alwaysTriggerOffsets:false
		}
	});
	
	var snapTo=[];
	$(".pcs-path-slider-outer-container pcs-path-slider-wrap.pcs-path-steps-without-slider .pcs-path-sin-slide-outer-wrap").each(function(){
		var $this=$(this),thisX=$this.position().left;
		snapTo.push(thisX);
	});
	function snapScrollbar(){
		var posX=$(".pcs-path-slider-outer-container .mCSB_container").position().left,closestX=findClosest(Math.abs(posX),snapTo);
		$(".pcs-path-slider-outer-container").mCustomScrollbar("scrollTo",closestX,{scrollInertia:800,callbacks:false});
	}
	function findClosest(num,arr){
		var curr=arr[0];
		var diff=Math.abs(num-curr);
		for(var val=0; val<arr.length; val++){
			var newdiff=Math.abs(num-arr[val]);
			if(newdiff<diff){
				diff=newdiff;
				curr=arr[val];
			}
		}
		return curr;
	}
	
	$('body').on('click', '.mCustomScrollBox>.mCSB_buttonLeft', function(e){
		e.preventDefault();
		$(this).closest('.mCustomScrollbar').find('.mCSB_scrollTools').find('.mCSB_buttonLeft').click();
	});
	$('body').on('click', '.mCustomScrollBox>.mCSB_buttonRight', function(e){
		e.preventDefault();
		$(this).closest('.mCustomScrollbar').find('.mCSB_scrollTools').find('.mCSB_buttonRight').click();
	});
	
	/***************************/
    if ($('.cat-testimonial-slider-wrap.wcslide-init').length) {
		const cat_testimonial_slider = document.querySelectorAll(".cat-testimonial-slider-wrap.wcslide-init");
        for (var i = 0; i < cat_testimonial_slider.length; i++) {
			var cat_testimonial_final_slider = cat_testimonial_slider[i];

			if ($(cat_testimonial_final_slider).hasClass('slick-initialized')) {
				$(cat_testimonial_final_slider).slick('unslick');
			}

			$(cat_testimonial_final_slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				infinite: true,
				mobileFirst: true,
				dots: false,
				arrows: true,
				prevArrow: '<button class="slick-arrow slick-prev"><svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4503 27.1099L15.9268 24.6054L5.30913 13.9998L15.9268 3.39418L13.4503 0.889648L0.32534 13.9998L13.4503 27.1099Z" fill="#606060"/></svg><div class="screen-reader-text">Previous</div></button>',
				nextArrow: '<button class="slick-arrow slick-next"><svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.54966 27.1099L0.0732422 24.6054L10.6909 13.9998L0.0732422 3.39418L2.54966 0.889648L15.6747 13.9998L2.54966 27.1099Z" fill="#606060"/></svg><div class="screen-reader-text">Next</div></button>',
				responsive: [
					{
						breakpoint: 1261,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 641,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					}
				]
			});
		}
    }
    /***************************/
	
	if($('#wpsl-search-input').length) {
		$('#wpsl-search-input').attr('placeholder', 'Enter city, zip code, or address');
	}
	
	function iframe_src_init() {
		var vidDefer = document.getElementsByTagName('iframe');
		for (var i=0; i<vidDefer.length; i++) {
			if(vidDefer[i].getAttribute('data-src')) {
				vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
			} 
		} 
	}
	window.onload = iframe_src_init;
	
	if($('.wpsl-contact-details').find('a[href^="tel:"]').length) {
		for(var cl=0; cl<$('.wpsl-contact-details').find('a[href^="tel:"]').length; cl++) {
			var c_href_data = $('.wpsl-contact-details').find('a[href^="tel:"]').eq(cl).attr('href');
			c_href_data = c_href_data.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '');
			$('.wpsl-contact-details').find('a[href^="tel:"]').eq(cl).attr('href', c_href_data);
		}
	}
	
	$('.table-index-l-dt-cnt-links-added-wrap').find('a[rel="relativeanchor"]').each(function(a,b) {
		if($(this).html().trim() == "Inspection") {
			var get_inspect_id = $(this).closest('.table-index-flex-data-wrap').find('.table-index-r-data-wrap').find('.table-index-img-cnt-outer-wrap').attr('id');
			if($(this).attr('href') != '#'+get_inspect_id) {
				$(this).attr('href', '#'+get_inspect_id);
			}
		}
	});
});
